export interface FuseNavigationItem {
    id: string;
    title: string;
    type: 'item' | 'group' | 'collapsable';
    iconType?: string;
    translate?: string;
    icon?: string;
    iconTooltip?: boolean;
    isShown?: boolean;
    isVisible?: boolean;
    url?: string;
    classes?: string;
    exactMatch?: boolean;
    externalUrl?: boolean;
    openInNewTab?: boolean;
    function?: any;
    translateTooltipHide?: boolean;
    badge?: {
        title?: string;
        translate?: string;
        bg?: string;
        fg?: string;
    };
    children?: FuseNavigationItem[];
    isDiable?: boolean;
}

export interface FuseNavigation extends FuseNavigationItem {
    children?: FuseNavigationItem[];
}
